import { Container } from '../components/Container';
import { PageHeader } from '../components/PageHeader';

export default function Legal() {
  return (
    <Container>
      <PageHeader title="Legal" />

      <div className="space-y-6">
        <div className="bg-white dark:bg-theme-dark-sidebar backdrop-blur-sm shadow rounded-lg p-6">
          <div className="space-y-4">
            <a
              href="https://juaai.notion.site/juaai/Jua-Legal-0ef8d8d4227c4dda95c431e15a6b9d57"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            >
              <h3 className="text-lg font-medium text-[#E34290]">Jua Legal</h3>
              <p className="text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary mt-1">
                Complete legal documentation and terms of service
              </p>
            </a>

            <a
              href="https://jua.ai/company/imprint"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            >
              <h3 className="text-lg font-medium text-[#E34290]">Imprint</h3>
              <p className="text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary mt-1">
                Legal notice and company information
              </p>
            </a>

            <a
              href="https://juaai.notion.site/Jua-Privacy-Policy-245d867d9bd446f7ab627c6205406c24"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            >
              <h3 className="text-lg font-medium text-[#E34290]">Data Privacy</h3>
              <p className="text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary mt-1">
                Privacy policy and data protection information
              </p>
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
}
